export interface NotificadaIdentity {
  razaoSocial: string;
  cnpj: string;
  sede?: string | null;
}

const CNPJ_RE = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

export const hasValidCnpj = (cnpj: string): boolean => CNPJ_RE.test(cnpj.trim());

export function formatNotificadaQualification({ razaoSocial, cnpj, sede }: NotificadaIdentity): string {
  const doc = cnpj.trim();
  const parts = [razaoSocial.trim().replace(/[\s,]+$/, ""), hasValidCnpj(doc) ? `inscrita no CNPJ sob o nº ${doc}` : "CNPJ a confirmar"];
  const s = sede?.trim();
  if (s) parts.push(`com sede em ${s}`);
  return parts.join(", ");
}
